import { Injectable } from '@angular/core';
import { StorageEntityName } from '../model/storage.model';
import { ActiveNavigation } from '../model/session-recovery.model';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class ActiveNavigationService {
  constructor(private readonly storage: StorageService) { }

  async saveActiveNavigation(navigation: ActiveNavigation): Promise<void> {
    await this.storage.set(StorageEntityName.activeNavigation, navigation);
  }

  async getActiveNavigation(): Promise<ActiveNavigation | null> {
    return await this.storage.get<ActiveNavigation>(
      StorageEntityName.activeNavigation
    );
  }

  async clearActiveNavigation(): Promise<void> {
    await this.storage.remove(StorageEntityName.activeNavigation);
  }

  /**
   * Persiste la ruta activa de una evaluación en curso al detectar una
   * navegación dentro de stablishment. Ignora rutas fuera de /stablishment/.
   */
  trackNavigation(url: string): void {
    // Excluir summary de la restauración
    if (url.startsWith('/stablishment/summary/')) {
      void this.clearActiveNavigation();
      return;
    }
    if (url.startsWith('/stablishment/')) {
      const parts = url.split('/');
      // parts: ['', 'stablishment', hash, ...]
      const hash = parts[2];
      if (hash) {
        void this.saveActiveNavigation({ hash, url });
        return;
      }
    }
    // Cualquier otra ruta (home, login, listado /stablishment, remotes) → descartar
    void this.clearActiveNavigation();
  }
}
